<div class="logo-wrap">
  <img src="../../../../assets/img/logo-creditemoi-no-contrast.png" alt="{{ alt }}" width="{{ width }}" height="{{ height }}" class="logo-img">
</div>
<div class="clearfix"></div>

